module.exports = __webpack_public_path__ + "images/stickers/taco-love.c17c5bf93797d71527ee.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-love.png
// module id = aCE+
// module chunks = 0